import { Component, Input } from '@angular/core';
import { DEFAULT_IMAGE_URL } from '@shared/utils';
import { LazyLoadImageModule } from 'ng-lazyload-image';


@Component({
    selector: 'app-detail-list-card',
    templateUrl: './detail-list-card.component.html',
    styleUrls: ['./detail-list-card.component.scss'],
    standalone: true,
    imports: [LazyLoadImageModule]
})
export class DetailListCardComponent {
  public defaultImage: string = DEFAULT_IMAGE_URL;

  @Input() list: any = [];

  constructor() {
  }

}
